import { FaEllipsisH, FaEllipsisV } from "react-icons/fa";

const InterviewCard = ({ application }) => {
  const date = new Date(application?.interviewed_on);
  const mois = date.toLocaleString('default', { month: 'long' });
  const jour = date.getDate();
  const heure = date.toLocaleString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  const recruteur = application?.offer?.recruiter_id; // Ou récupérez cette information si disponible
  const titre = application?.offer?.job_title;
  const lieu = application?.offer?.address;
  const statut = application?.status;
  const createur = "Nom du recruteur"; // Remplacez par le nom réel du créateur
  const { message, score, note } = application;

  return (
    <div className="bg-white p-4 rounded-lg shadow-md divide-y">
      {/* En-tête avec la date et les détails de l'entretien */}
      <div className="flex justify-between items-start mb-3">
        {/* Section Date */}
        <div className="flex justify-start gap-4 items-center">
          <div className="flex flex-col items-center bg-gray-100 p-4 rounded-lg shadow-sm">
            <div className="absolute -mt-5 w-10 flex justify-between">
              <span className="w-1.5 h-4 bg-gray-300 rounded-md -rotate-2"></span>
              <span className="w-1.5 h-4 bg-gray-300 rounded-md rotate-2"></span>
            </div>
            <span className="text-2xl font-bold">{jour}</span>
            <span className="text-sm text-gray-500">{mois}</span>
          </div>
          <div className="flex flex-col">
            <h3 className="font-semibold text-lg">{titre}</h3>
            <p className="text-sm text-gray-500">
              {heure} • avec {recruteur}
            </p>
          </div>
        </div>
        <FaEllipsisH className="text-gray-500 cursor-pointer" />
      </div>

      {/* Section Détails de l'entretien */}
      <div className="flex items-start justify-between space-x-4 pt-3">
        <div className="flex-1">
          <div className="grid grid-cols-3 gap-4 mt-3 text-sm text-gray-600">
            <div>
              <p className="font-semibold">Lieu</p>
              <p className="text-black">{lieu}</p>
            </div>
            <div>
              <p className="font-semibold">Statut</p>
              <p className="flex items-center space-x-1">
                <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                <span className="text-green-600">{statut}</span>
              </p>
            </div>
            <div>
              <p className="font-semibold">Créé par</p>
              <p className="text-black">{createur}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Section Informations supplémentaires */}
      <div className="mt-4">
        <p className="font-semibold text-sm">Message du candidat :</p>
        <p className="text-gray-600 text-sm">{message}</p>
        <p className="mt-2 font-semibold text-sm">Évaluation :</p>
        <p className="text-gray-600 text-sm">Score : {score} | Note : {note}</p>
      </div>
    </div>
  );
};

// const InterviewCard = ({ date, month, title, time, interviewer, location, status, creator }) => {
//   const InterviewCard = ({ application }) => {
//   return (
//     <div className="bg-white p-4 rounded-lg shadow-md  divide-y">
//         <div className="flex justify-between items-start mb-3">
//               {/* Date Section */}
//               <div className="flex justify-start gap-2 items-center">
//                   <div className="flex flex-col items-center bg-gray-100 p-3 rounded-lg w-16 shadow-sm">
//                     <div className="absolute -mt-5 w-10 flex justify-between">
//                          <span className="w-1.5 h-4 bg-gray-300  rounded-md -rotate-2"></span>
//                         <span className="w-1.5 h-4 bg-gray-300  rounded-md rotate-2"></span>
//                     </div>
                 
//         <span className="text-xl font-bold">{date}</span>
//         <span className="text-sm text-gray-500">{month}</span>
        
//       </div>
//       <div className="flex flex-col">
//       <h3 className="font-semibold text-lg">{title}</h3>
//         <p className="text-sm text-gray-500">{time} • with {interviewer}</p>

//       </div>
//               </div>
    
//       <FaEllipsisH className="text-gray-500 cursor-pointer" />
//         </div>
    

//       {/* Details */}
//       <div className="flex items-start justify-between space-x-4 pt-3">
//       <div className="flex-1">
        

//         <div className="grid grid-cols-3 gap-4 mt-3 text-sm text-gray-600">
//           <div>
//             <p className="font-semibold">Location</p>
//             <p className="text-black">{location}</p>
//           </div>
//           <div>
//             <p className="font-semibold">Status</p>
//             <p className="flex items-center space-x-1">
//               <span className="w-2 h-2 bg-green-500 rounded-full"></span>
//               <span className="text-green-600">{status}</span>
//             </p>
//           </div>
//           <div>
//             <p className="font-semibold">Created by</p>
//             <p className="text-black">{creator}</p>
//           </div>
//         </div>
//       </div>

//       {/* Actions */}
//       {/* <div className="flex flex-col items-end space-y-2">
//         <button className="border border-gray-500 text-gray-600 px-4 py-2 rounded-md">
//           View Details
//         </button>
        
//       </div> */}
//       </div>

    
//     </div>
//   );
// };

const InterviewList = ({application}) => {
  // const interviews = [
  //   {
  //     date: "01",
  //     month: "Oct",
  //     title: "Aptitude Test",
  //     time: "11:00AM - 12:00AM",
  //     interviewer: "Bagus Fikri",
  //     location: "Online",
  //     status: "Completed",
  //     creator: "Raihan Fikri",
  //   },
  //   {
  //     date: "05",
  //     month: "Oct",
  //     title: "Written Test",
  //     time: "11:00AM - 12:00AM",
  //     interviewer: "Bagus Fikri",
  //     location: "Online",
  //     status: "Completed",
  //     creator: "Raihan Fikri",
  //   },
  // ];

  return (
    <div className="max-w-2xl mx-auto space-y-4">
      {/* {interviews.map((interview, index) => ( */}
        <InterviewCard application={application} />
      {/* ))} */}
      
      {/* Add Interview Button */}
      <button className="flex items-center space-x-2 text-gray-600 border px-4 py-2 rounded-md">
        <span className="text-lg">+</span>
        <span>Add Interview</span>
      </button>
    </div>
  );
};

export default InterviewList;
